module.exports = __webpack_public_path__ + "f32d22e2b7532f752fc5d29bf804d008.png";